import React from 'react';

const Crew = (extraStyles?: React.CSSProperties) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={extraStyles}>
            <path d="M13.3332 17.5V15.8333C13.3332 14.9493 12.982 14.1014 12.3569 13.4763C11.7317 12.8512 10.8839 12.5 9.99984 12.5H4.99984C4.11578 12.5 3.26794 12.8512 2.64281 13.4763C2.01769 14.1014 1.6665 14.9493 1.6665 15.8333V17.5M18.3332 17.5V15.8333C18.3326 15.0948 18.0868 14.3773 17.6343 13.7936C17.1818 13.2099 16.5483 12.793 15.8332 12.6083M13.3332 2.60833C14.0502 2.79192 14.6857 3.20892 15.1395 3.79359C15.5934 4.37827 15.8397 5.09736 15.8397 5.8375C15.8397 6.57764 15.5934 7.29673 15.1395 7.88141C14.6857 8.46608 14.0502 8.88308 13.3332 9.06667M10.8332 5.83333C10.8332 7.67428 9.34079 9.16667 7.49984 9.16667C5.65889 9.16667 4.1665 7.67428 4.1665 5.83333C4.1665 3.99238 5.65889 2.5 7.49984 2.5C9.34079 2.5 10.8332 3.99238 10.8332 5.83333Z" stroke="inherit" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default Crew;

